import awards from "../../shared/pt.awards";
import branded_quotes from "../../shared/pt.branded-quotes";
import verticals from "./pt-consumer.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "pt-consumer-404":
            return {
                page,
                helmet: {
                    meta_title: "Página não encontrada | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://pt.rosettastone.com/404",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        case "pt-consumer-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos | Rosetta Stone",
                    meta_description:
                        "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
                    canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "pt-consumer-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos | Rosetta Stone",
                    meta_description:
                        "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
                    canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "pt-consumer-home":
            return {
                page,
                helmet: {
                    meta_title: "Rosetta Stone® Oficial - O Melhor Curso de Idiomas Online",
                    meta_description:
                        "Rosetta Stone é a melhor maneira de aprender Inglês e outros idiomas. Com a melhor ferramenta de reconhecimento de voz do mundo, on-line ou off-line, nosso aplicativo premiado fala por si.",
                    canonical_url: "https://pt.rosettastone.com/",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
